export const usmle1PharmModule = {
  id: "pharm",
  title: "Pharmacology",
  sections: [
    {
      type: "text",
      content:
        "Competitive inhibitors increase Km; noncompetitive inhibitors decrease Vmax.",
    },
    {
      type: "question",
      text: "A noncompetitive inhibitor causes which change?",
      options: ["Increased Km", "Decreased Km", "Decreased Vmax", "Increased Vmax"],
      correct: 2,
      explanation: "Noncompetitive inhibition decreases Vmax without changing Km.",
    },
  ],
};
